// extracted by mini-css-extract-plugin
export default {"panel":"forms_panel__aV7+H","field":"forms_field__v+Lb6"};